// extracted by mini-css-extract-plugin
export default {"loader":"feedPostPage_loader__mkUvQ","stripes-animation-background-keyframes":"feedPostPage_stripes-animation-background-keyframes__EAJau"};